import { Modal, Row, Col, Spinner, Badge } from 'reactstrap';
import { motion } from 'framer-motion';
import { formatRoleName } from '../constants/utils';

const ReportedByModal = ({
  isOpen,
  toggle,
  userData,
  loading,
  formatCreatedDate,
  onTicketClick
}) => {
  if (!userData) return null;

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
      className="fade-scale-modal"
      style={{ maxHeight: '80vh' }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.2 }}
      >
        <div className="modal-header" style={{ position: 'sticky', top: 0, background: 'white', zIndex: 2 }}>
          <h5 className="modal-title">User Details - {userData.name}</h5>
          <button
            type="button"
            className="btn-close"
            onClick={toggle}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body" style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          paddingTop: '0',
          maxHeight: 'calc(80vh - 60px)',
          overflow: 'auto'
        }}>
          {loading ? (
            <div className="text-center py-4">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <Row className="mb-4">
                <Col md={6}>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Name:</span>
                    <span className="detail-value d-block" style={{ color: '#212529' }}>{userData.name}</span>
                  </div>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Email:</span>
                    <span className="detail-value d-block">{userData.email || 'N/A'}</span>
                  </div>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Username:</span>
                    <span className="detail-value d-block">{userData.username || 'N/A'}</span>
                  </div>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Contact Number:</span>
                    <span className="detail-value d-block">
                      {userData.phoneCode ? `+${userData.phoneCode} ` : ''}
                      {userData.contactNumber || 'N/A'}
                    </span>
                  </div>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Organization Name:</span>
                    <span className="detail-value d-block">{userData.organization.name || 'N/A'}</span>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Role:</span>
                    <span className="detail-value d-block">{formatRoleName(userData.role) || 'N/A'}</span>
                  </div>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Verification Status:</span>
                    <span className="detail-value d-block">
                      <Badge color={userData.verified ? 'success' : 'danger'}>
                        {userData.verified ? 'Verified' : 'Not Verified'}
                      </Badge>
                    </span>
                  </div>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Profile Image:</span>
                    {userData.profileUrl ? (
                      <img 
                        src={userData.profileUrl} 
                        alt="Profile" 
                        style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }}
                      />
                    ) : (
                      <span className="detail-value d-block">N/A</span>
                    )}
                  </div>
                  <div className="mb-3">
                        <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Organization Contact:</span>
                        <span className="detail-value d-block">{userData.organization.contactNumber || 'N/A'}</span>
                      </div>
                      <div className="mb-3">
                        <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Attendance Status:</span>
                        <span className="detail-value d-block">
                          <Badge color={userData.attendanceStatus === 'ONLINE' ? 'success' : 'secondary'}>
                            {userData.attendanceStatus === 'ONLINE' ? 'Online' : 'Offline'}
                          </Badge>
                        </span>
                      </div>
                </Col>
              </Row>

              <h5 className="mb-3">Recent Work Orders</h5>
              {userData.reportedIssues?.length > 0 ? (
                <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                  <table className="table table-sm">
                    <thead style={{ position: 'sticky', top: 0, background: 'white', zIndex: 1 }}>
                      <tr>
                        <th>Ticket #</th>
                        <th>Issue Date</th>
                        <th>Asset</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userData.reportedIssues.map((issue) => (
                        <tr key={issue.id}>
                        <td>
                            <span 
                                className="text-primary cursor-pointer hover-underline"
                                onClick={() => onTicketClick(issue.ticketNumber)}
                                style={{ cursor: 'pointer' }}
                            >
                                {issue.ticketNumber}
                            </span>
                        </td>
                          <td>{formatCreatedDate(issue.createdAt)}</td>
                          <td>{issue.asset?.assetName || 'N/A'}</td>
                          <td>
                            <Badge color={
                              issue.status === 'SUBMITTED' ? 'info' :
                              issue.status === 'IN_PROGRESS' ? 'warning' :
                              issue.status === 'ON_HOLD' ? 'danger' :
                              issue.status === 'PENDING' ? 'primary' :
                              issue.status === 'RESOLVED' ? 'success' : 'secondary'
                            }>
                              {issue.status === 'SUBMITTED' ? 'OPEN' : issue.status}
                            </Badge>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="alert alert-info">No recent work orders found</div>
              )}
            </>
          )}
        </div>
      </motion.div>
    </Modal>
  );
};

export default ReportedByModal;